var _style, _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoPdlShort(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#231F20;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#ED1C24;}\n")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pdl_logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "st0",
    d: "M15,30c8.3,0,15-6.7,15-15S23.3,0,15,0S0,6.7,0,15c0,4,1.6,7.8,4.4,10.6S11,30,15,30L15,30z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1_",
    className: "st1",
    d: "M15,29.3c7.9,0,14.3-6.4,14.3-14.3S22.9,0.7,15,0.7S0.7,7.1,0.7,15c0,3.8,1.5,7.4,4.2,10.1 S11.2,29.3,15,29.3L15,29.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2_",
    className: "st2",
    d: "M15,28.6c7.4,0,13.5-6,13.5-13.5S22.4,1.6,15,1.6S1.5,7.7,1.5,15.1c0,3.6,1.4,7,3.9,9.5 S11.4,28.6,15,28.6L15,28.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "st1",
    d: "M18.3,5.9c0-2.2-1.1-2.2-2.4-2.2h-3.1v22.4h3.1c1.2,0,2.3-0.3,2.3-1.8C18.3,5.5,18.4,8.3,18.3,5.9 z M16.3,6.6v16.5c0,0.9-0.2,0.9-0.6,0.9H15V5.8h0.7C16.2,5.8,16.3,6.1,16.3,6.6z M11.5,8.5c-0.1-1.8-1.6-2-2.6-2H6V24H8v-4.5h1.2 c2.1,0,2.3-0.6,2.3-2.4V8.5z M9.3,16.3c0,0.7-0.3,1.1-0.9,1.1H7.9V8.6h0.7c0.5,0,0.7,0.1,0.7,0.7V16.3z M24.5,21.9l0.1,2h-4.8V6.5 h2.1v15.4H24.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPdlShort);
export default __webpack_public_path__ + "static/media/logo-pdl-short.cc77b8422b2c9e3518b4149778eda44f.svg";
export { ForwardRef as ReactComponent };